'use client';
import React, { useState } from 'react';
import { MapPin, Plus, Minus, Hotel, Utensils, Coffee, Eye, CheckCircle, X } from 'lucide-react';

const packages = [
  {
    title: 'Vietnam Tour Package',
    nights: '5N | 6D',
    label: 'With Flight',
    price: '₹ 1,35,000*',
    image: "https://trip.saishishirtours.in/wp-content/uploads/2025/07/Da-Nang-Package-scaled.webp",
    itinerary: [
  {
    day: "Day 1",
    title: "Arrival at Da Nang",
    details: "Arrival at Da Nang, hotel check-in, My Khe Beach, and Dragon Bridge.",
    listItems: [
      "Arrive at Da Nang International Airport, meet and greet with the local representative.",
      "Lunch at an Indian restaurant.",
      "Check in to the hotel (Nesta Da Nang / Nalod Hotel / Similar) and relax.",
      "Evening visit to My Khe Beach, one of the most beautiful beaches in Asia.",
      "Visit the famous Dragon Bridge and enjoy the lively atmosphere of Da Nang city.",
      "Dinner at an Indian restaurant.",
      "Overnight stay in Da Nang."
    ]
  },
  {
    day: "Day 2",
    title: "Ba Na Hills Tour",
    details: "Full-day Ba Na Hills tour by cable car including Golden Hand Bridge, French Village, and Fantasy Park.",
    listItems: [
      "After breakfast, proceed to the famous Ba Na Hills by cable car.",
      "Visit the iconic Golden Hand Bridge.",
      "Explore the French Village.",
      "Enjoy attractions at Fantasy Park.",
      "Take in beautiful mountain views and gardens.",
      "Lunch at Ba Na Hills.",
      "Return to Da Nang. Dinner at an Indian restaurant.",
      "Overnight stay in Da Nang (Nesta Da Nang / Nalod Hotel / Similar)."
    ]
  },
  {
    day: "Day 3",
    title: "Da Nang City Tour & Hoi An",
    details: "Da Nang city tour covering Linh Ung Pagoda, Lady Buddha, and Marble Mountains, followed by Hoi An Ancient Town in the evening.",
    listItems: [
      "After breakfast, proceed for the Da Nang city tour.",
      "Visit Linh Ung Pagoda.",
      "Visit the towering Lady Buddha Statue.",
      "Explore the Marble Mountains.",
      "Lunch at a local / Indian restaurant.",
      "Evening visit to Hoi An Ancient Town: Basket Boat Ride, Lantern Boat Ride, local market and ancient streets.",
      "Dinner at an Indian restaurant.",
      "Overnight stay in Da Nang."
    ]
  },
  {
    day: "Day 4",
    title: "Da Nang to Hanoi",
    details: "Flight to Hanoi, city tour covering One Pillar Pagoda, Ho Chi Minh Mausoleum, Train Street, and the famous Water Puppet Show.",
    listItems: [
      "After breakfast, check out and transfer to the airport for your flight to Hanoi.",
      "Lunch on arrival.",
      "Hanoi city tour: One Pillar Pagoda.",
      "Ho Chi Minh Mausoleum (outside view if closed).",
      "Visit the famous Train Street.",
      "Evening Vietnam Water Puppet Show.",
      "Dinner at an Indian restaurant.",
      "Overnight stay in Hanoi (Army Hotel / Nesta Hanoi / La Casa / Similar)."
    ]
  },
  {
    day: "Day 5",
    title: "Hanoi to Ha Long Bay Cruise",
    details: "Transfer to Ha Long Bay, board the cruise, and enjoy Ti Top Island and kayaking activities.",
    listItems: [
      "Early breakfast and check out from the hotel.",
      "Proceed to Ha Long Bay.",
      "Check in to the cruise (Amanda Hera Cruise / Similar) with welcome drinks.",
      "Lunch onboard.",
      "Evening visit to Ti Top Island.",
      "Kayaking activities.",
      "Delicious dinner onboard with authentic local cuisine.",
      "Overnight stay on the Ha Long Bay Cruise."
    ]
  },
  {
    day: "Day 6",
    title: "Ha Long Bay – Hanoi Airport Drop",
    details: "Visit the magnificent Surprise Cave, breakfast and brunch onboard, then transfer to Hanoi Airport for departure.",
    listItems: [
      "Early morning visit to the magnificent Surprise Cave.",
      "Return to the cruise for breakfast and brunch.",
      "Check out from the cruise.",
      "Transfer back to Hanoi Airport for your return journey home."
    ]
  }
]

  },
  {
    title: 'Vietnam & Cambodia Tour Package',
    nights: '7N | 8D',
    label: 'With Flight',
    price: '₹ 1,75,000*',
    image: "https://trip.saishishirtours.in/wp-content/uploads/2025/07/Vietnam-Cambodia-4-scaled.webp",
    itinerary: [
  {
    day: "Day 1",
    title: "Arrival in Da Nang",
    details: "Arrival in Da Nang, hotel check-in, Marble Mountains, Linh Ung Pagoda, and Dragon Bridge.",
    listItems: [
      "Arrive in Da Nang and transfer to hotel for check-in.",
      "Visit the Marble Mountains – explore caves, temples, and scenic viewpoints.",
      "Head to Lady Buddha at Linh Ung Pagoda for panoramic views of Da Nang coastline.",
      "Evening visit to Dragon Bridge.",
      "Sample local Vietnamese cuisine."
    ]
  },
  {
    day: "Day 2",
    title: "Ba Na Hills Day Trip",
    details: "Day trip to Ba Na Hills including Golden Bridge, French Village, and theme park.",
    listItems: [
      "Trip to Ba Na Hills.",
      "Visit the Golden Bridge.",
      "Explore the French Village.",
      "Enjoy the theme park and scenic cable car rides.",
      "Return to Da Nang and unwind or experience city nightlife."
    ]
  },
  {
    day: "Day 3",
    title: "Ancient Town & Japanese Covered Bridge",
    details: "Explore Hoi An with coconut groves, local life, Ancient Town, and Japanese Covered Bridge.",
    listItems: [
      "Experience water coconut groves.",
      "Participate in local activities and learn about fishermen’s lives.",
      "Explore Hoi An’s Ancient Town.",
      "Visit Japanese Covered Bridge and Tan Ky House.",
      "Taste local street food.",
      "Return to Da Nang after sunset."
    ]
  },
  {
    day: "Day 4",
    title: "Da Nang to Hanoi",
    details: "Fly to Hanoi, explore Ho Chi Minh Mausoleum, Old Quarter, and Water Puppet Show.",
    listItems: [
      "Fly to Hanoi and check into hotel.",
      "Visit Ho Chi Minh Mausoleum.",
      "Stop at the historic Single Pillar Pagoda.",
      "Walking tour of Hanoi’s Old Quarter including Hoan Kiem Lake.",
      "Enjoy a traditional Water Puppet Show.",
      "Sample local dishes in the Old Quarter."
    ]
  },
  {
    day: "Day 5",
    title: "Ninh Binh Day Trip",
    details: "Day trip to Ninh Binh with boat ride at Tam Coc and Hoa Lu visit.",
    listItems: [
      "Embark on a day trip to Ninh Binh.",
      "Visit Tam Coc for a scenic boat ride among limestone karsts.",
      "Explore the ancient capital of Hoa Lu.",
      "Return to Hanoi in the evening."
    ]
  },
  {
    day: "Day 6",
    title: "Hanoi to Ha Long Bay",
    details: "Travel to Ha Long Bay and enjoy cruise activities including kayaking, caves, and dinner onboard.",
    listItems: [
      "Travel from Hanoi to Ha Long Bay.",
      "Board your cruise.",
      "Enjoy kayaking, swimming, and exploring caves.",
      "Dinner served on board.",
      "Overnight stay on the cruise."
    ]
  },
  {
    day: "Day 7",
    title: "Ha Long Bay to Siem Reap",
    details: "Conclude cruise, return to Hanoi, and fly to Siem Reap.",
    listItems: [
      "Conclude Ha Long Bay cruise.",
      "Return to Hanoi.",
      "Catch flight to Siem Reap, Cambodia.",
      "Check into hotel in Siem Reap.",
      "Evening free to relax."
    ]
  },
  {
    day: "Day 8",
    title: "Angkor Wat & Siem Reap Exploration",
    details: "Visit Angkor Wat, Angkor Thom, Bayon, Ta Prohm, and Siem Reap night market.",
    listItems: [
      "Visit Angkor Wat at sunrise.",
      "Explore Angkor Thom and Bayon Temple.",
      "Visit Ta Prohm Temple with its overgrown trees.",
      "Return to Siem Reap.",
      "Explore Siem Reap night market."
    ]
  },
  {
    day: "Day 9",
    title: "Departure from Siem Reap",
    details: "Free time in Siem Reap before departure.",
    listItems: [
      "Morning free for relaxation or last-minute shopping.",
      "Depart from Siem Reap in the afternoon.",
      "End of trip."
    ]
  }
]

  }
];

export default function BhutanPackages() {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [expandedDays, setExpandedDays] = useState([]);
  const [allExpanded, setAllExpanded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleDay = (dayNumber) => {
    setExpandedDays(prev =>
      prev.includes(dayNumber)
        ? prev.filter(day => day !== dayNumber)
        : [...prev, dayNumber]
    );
  };

  const toggleAllDays = () => {
    if (allExpanded) {
      setExpandedDays([]);
      setAllExpanded(false);
    } else {
      const allDayNumbers = selectedPackage?.itinerary.map((_, index) => index) || [];
      setExpandedDays(allDayNumbers);
      setAllExpanded(true);
    }
  };

  const handleContactSupport = () => {
    const heroElement = document.getElementById('hero-section');
    if (heroElement) {
      heroElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const openModal = (item) => {
    setSelectedPackage(item);
    setIsModalOpen(true);
    setExpandedDays([]);
    setAllExpanded(false);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedPackage(null);
    setExpandedDays([]);
    setAllExpanded(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <div style={{ padding: '40px 20px', minHeight: '100vh' }}>
      <h4 className='display-5 fw-bold mb-3 blue-brand-color text-center pb-3'>
        Best Vietnam Tour Packages
      </h4>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
        gap: '24px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {packages.map((item, i) => (
          <div key={i} style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            position: 'relative',
            cursor: 'pointer'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-8px)';
            e.currentTarget.style.boxShadow = '0 12px 40px rgba(0,0,0,0.15)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.1)';
          }}>
            <div style={{ position: 'relative', height: '240px', overflow: 'hidden' }}>
              <img
                src={item.image}
                alt={item.title}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease'
                }}
              />
              <div style={{
                position: 'absolute',
                top: '12px',
                right: '12px',
                backgroundColor: item.label === 'With Flight' ? '#16a34a' : '#ff9f26',
                color: 'white',
                padding: '6px 12px',
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: '600'
              }}>
                {item.label}
              </div>
            </div>

            <div style={{ padding: '20px' }}>
              <div style={{ marginBottom: '16px' }}>
                <h6 style={{
                  fontSize: '20px',
                  fontWeight: '600',
                  color: '#1f2937',
                  margin: '0 0 8px 0'
                }}>
                  {item.title}
                </h6>
                <p style={{
                  fontSize: '14px',
                  color: '#6b7280',
                  margin: 0,
                  fontWeight: '500'
                }}>
                  {item.nights}
                </p>
              </div>

              <div style={{
                backgroundColor: '#f0f9ff',
                padding: '12px',
                borderRadius: '8px',
                marginBottom: '20px',
                textAlign: 'center',
                border: '1px solid #e0f2fe'
              }}>
                <p style={{
                  margin: 0,
                  fontSize: '14px',
                  color: '#0f172a'
                }}>
                  starting at <strong className='orange-brand-color' style={{
                    fontSize: '18px',

                  }}>{item.price}</strong>
                </p>
              </div>

              <div style={{
                display: 'flex',
                gap: '8px',
                justifyContent: 'center'
              }}>
                <button
                  style={{
                    backgroundColor: '#0b4878',
                    color: 'white',
                    border: 'none',
                    padding: '10px 20px',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    flex: 1
                  }}
                  onClick={handleContactSupport}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = '#0b4878';
                    e.target.style.transform = 'translateY(-1px)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = '#0b4878';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  BOOK NOW
                </button>
                <button
                  style={{
                    backgroundColor: 'transparent',
                    color: '#0b4878',
                    border: '2px solid #ff9f26',
                    padding: '10px 20px',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    flex: 1
                  }}
                  onClick={() => openModal(item)}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = '#ff9f26';
                    e.target.style.color = 'white';
                    e.target.style.transform = 'translateY(-1px)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#ff9f26';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  ITINERARY
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modern Modal */}
      {isModalOpen && selectedPackage && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          padding: '20px',
          backdropFilter: 'blur(4px)'
        }} onClick={closeModal}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '20px',
            width: '100%',
            maxWidth: '900px',
            maxHeight: '90vh',
            overflow: 'hidden',
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)',
            transform: 'scale(1)',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
          }} onClick={(e) => e.stopPropagation()}>

            {/* Modal Header */}
            <div className='bg-background' style={{
              padding: '24px',
              borderBottom: '1px solid #e5e7eb',
              color: 'white',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div>
                <h5 style={{
                  margin: 0,
                  fontSize: 'clamp(20px, 3vw, 24px)',
                  fontWeight: '700'
                }}>
                  {selectedPackage.title} - {selectedPackage.nights}
                </h5>
                <p style={{
                  margin: '4px 0 0 0',
                  opacity: 0.9,
                  fontSize: '14px'
                }}>
                  Detailed Itinerary
                </p>
              </div>
              <button
                onClick={closeModal}
                style={{
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '8px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                onMouseOver={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.3)';
                  e.target.style.transform = 'scale(1.05)';
                }}
                onMouseOut={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                <X size={20} color="white" />
              </button>
            </div>

            {/* Modal Body with Timeline */}
            <div style={{
              height: '70vh',
              overflowY: 'auto',
              padding: '0'
            }}>

              {/* Controls Header */}
              <div style={{
                padding: '20px 24px',
                backgroundColor: '#f8fafc',
                borderBottom: '1px solid #e5e7eb',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '12px'
              }}>
                <h6 style={{
                  margin: 0,
                  color: '#374151',
                  fontSize: '16px',
                  fontWeight: '600'
                }}>
                  Day-wise Itinerary
                </h6>
                <button
                  style={{
                    color: allExpanded ? 'white' : '#0b4878',
                    fontSize: '14px',
                    fontWeight: '600',
                    border: '2px solid #0b4878',
                    backgroundColor: allExpanded ? '#2563eb' : 'transparent',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onClick={toggleAllDays}
                  onMouseOver={(e) => {
                    if (!allExpanded) {
                      e.target.style.backgroundColor = '#0b4878';
                      e.target.style.color = 'white';
                    }
                    e.target.style.transform = 'scale(1.05)';
                  }}
                  onMouseOut={(e) => {
                    if (!allExpanded) {
                      e.target.style.backgroundColor = 'transparent';
                      e.target.style.color = '#2563eb';
                    }
                    e.target.style.transform = 'scale(1)';
                  }}
                >
                  {allExpanded ? 'Collapse All' : 'Expand All'}
                </button>
              </div>

              {/* Timeline Container */}
              <div style={{
                padding: '24px',
                position: 'relative',
                backgroundColor: '#fafafa'
              }}>
                {/* Vertical Timeline Line */}
                {/* <div style={{
                  position: 'absolute',
                  left: '40px',
                  top: '24px',
                  bottom: '24px',
                  width: '3px',
                  background: 'linear-gradient(to bottom, #2563eb, #60a5fa)',
                  borderRadius: '2px'
                }}></div> */}

                {selectedPackage.itinerary.map((dayData, index) => {
                  const isExpanded = expandedDays.includes(index);
                  const hasContent = dayData.details || dayData.sightseeing?.length > 0;

                  return (
                    <div key={index} style={{
                      position: 'relative',
                      marginBottom: '20px'
                    }}>
                      {/* Timeline Dot */}
                      {/* <div style={{
                        position: 'absolute',
                        left: '28px',
                        top: '20px',
                        width: '24px',
                        height: '24px',
                        backgroundColor: isExpanded ? '#2563eb' : '#60a5fa',
                        borderRadius: '50%',
                        border: '4px solid white',
                        boxShadow: '0 2px 8px rgba(37, 99, 235, 0.3)',
                        zIndex: 10,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                        transform: isExpanded ? 'scale(1.1)' : 'scale(1)'
                      }}>
                        <MapPin size={12} color="white" />
                      </div> */}

                      {/* Day Card */}
                      <div style={{

                        backgroundColor: 'white',
                        borderRadius: '16px',
                        boxShadow: isExpanded ? '0 8px 25px rgba(0,0,0,0.15)' : '0 4px 15px rgba(0,0,0,0.1)',
                        overflow: 'hidden',
                        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                        border: isExpanded ? '2px solid #2563eb' : '1px solid #e5e7eb'
                      }}>
                        {/* Day Header */}
                        <div
                          style={{
                            padding: '20px',
                            cursor: hasContent ? 'pointer' : 'default',
                            backgroundColor: isExpanded ? '#eff6ff' : 'white',
                            borderBottom: isExpanded ? '1px solid #e0e7ff' : 'none',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                          }}
                          onClick={() => hasContent && toggleDay(index)}
                        >
                          <div style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            justifyContent: 'space-between'
                          }}>
                            <div style={{ flex: 1 }}>
                              <div style={{
                                fontSize: '14px',
                                color: '#2563eb',
                                fontWeight: '600',
                                marginBottom: '6px',
                                letterSpacing: '0.5px'
                              }}>
                                {dayData.day}
                              </div>
                              <div style={{
                                color: '#1f2937',
                                fontWeight: '600',
                                fontSize: 'clamp(16px, 2vw, 18px)',
                                lineHeight: '1.4'
                              }}>
                                {dayData.title || dayData.day}
                              </div>
                            </div>
                            {hasContent && (
                              <div style={{
                                marginLeft: '16px',
                                padding: '8px',
                                borderRadius: '8px',
                                backgroundColor: isExpanded ? '#2563eb' : '#f3f4f6',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'
                              }}>
                                {isExpanded ? (
                                  <Minus size={18} color="white" />
                                ) : (
                                  <Plus size={18} color="#6b7280" />
                                )}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Expanded Content */}
                        <div style={{
                          maxHeight: isExpanded ? '1000px' : '0',
                          opacity: isExpanded ? 1 : 0,
                          overflow: 'hidden',
                          transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
                        }}>
                          {hasContent && (
                           <div style={{ padding: '20px' }}>
  {/* Description */}
  {dayData.details && (
    <div style={{
      color: '#4b5563',
      fontSize: '15px',
      lineHeight: '1.6',
      margin: '0'
    }}>
      <p style={{ marginBottom: '16px' }}>
        {dayData.details.split('<ul>')[0].replace(/<\/?p>/g, '')}
      </p>

      {/* Custom styled list with check icons */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        margin: '16px 0'
      }}>
        {dayData.listItems && dayData.listItems.map((item, idx) => (
          <div key={idx} style={{
            display: 'flex',
            alignItems: 'center'
          }}>
            <CheckCircle size={16} color="#16a34a" style={{
              marginRight: '12px',
              flexShrink: 0
            }} />
            <span style={{
              fontSize: '14px',
              color: '#374151',
              fontWeight: '500'
            }}>{item}</span>
          </div>
        ))}
      </div>
    </div>
  )}
</div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Modal Footer */}
            <div style={{
              padding: '20px 24px',
              borderTop: '1px solid #e5e7eb',
              backgroundColor: '#f8fafc',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '12px'
            }}>
              <div style={{ fontSize: '14px', color: '#6b7280' }}>
                <span style={{ fontWeight: '600' }}>Starting at {selectedPackage.price}</span>
              </div>
              <div style={{ display: 'flex', gap: '12px' }}>
                <button
                  onClick={closeModal}
                  style={{
                    padding: '10px 20px',
                    border: '2px solid #6b7280',
                    backgroundColor: 'transparent',
                    color: '#6b7280',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = '#6b7280';
                    e.target.style.color = 'white';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#6b7280';
                  }}
                >
                  Close
                </button>
                <button
                  onClick={() => {
                    closeModal();
                    handleContactSupport();
                  }}
                  style={{
                    padding: '10px 24px',
                    border: 'none',
                    backgroundColor: '#0b4878',
                    color: 'white',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = '#0b4878';
                    e.target.style.transform = 'translateY(-1px)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = '#0b4878';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Book This Package
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
